import { render, staticRenderFns } from "./ListPaciente.vue?vue&type=template&id=60e55c0c&scoped=true&"
import script from "./ListPaciente.vue?vue&type=script&lang=js&"
export * from "./ListPaciente.vue?vue&type=script&lang=js&"
import style0 from "./ListPaciente.vue?vue&type=style&index=0&id=60e55c0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e55c0c",
  null
  
)

export default component.exports